/**
 * Owner: Masa Bayu
 * File: dedicated-format.ts
 * Date:Time: 2026-10-23 09:10
 * Description: Minor-unit money formatting for the dedicated author screens.
 *   §466 S1 — jumlah memakai pembentuk canonical (koma ribuan wajib); kod mata
 *   wang kekal suffix kerana ledger author boleh membawa kod di luar USD/MYR.
 */

import { formatMarketplaceAmount } from '../../home/marketplace/marketplace-locale';

export function formatMinor(minorUnits: number, currency: string): string {
  return `${formatMarketplaceAmount(minorUnits)} ${currency}`;
}
